import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";

export const findpreFilter = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-wallet/v1/balance/detailsList?` + params,
    method: "GET",
  });
};
export function uploadFile(params) {
  return request({
    url: `${baseUrl}/joins-wallet/v1/balance/importXlsV2`,
    method: "post",
    ContentType: "multipart/form-data",
    data: params,
  });
}
export function downloadCheckingXls1() {
  return request({
    url: `${baseUrl}/joins-wallet/v1/balance/downloadCheckingXls1`,
    method: "GET",
  });
}
export function downloadCheckingXls(params) {
  return request({
    url: `${baseUrl}/joins-wallet/v1/balance/downloadCheckingXls`,
    method: "post",
    ContentType: "multipart/form-data",
    responseType: "blob",
    data: params,
  });
}
export function downloadExcelData(params) {
  return request({
    url: `${baseUrl}/joins-wallet/v1/balance/downloadExcelData`,
    method: "post",
    ContentType: "multipart/form-data",
    responseType: "blob",
    data: params,
  });
}
export const v1BalanceExcel = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-wallet/v1/balance/downloadExcel?` + params,
    method: "GET",
  });
};
export const findUserList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-basic/v1/user/findUserList?` + params,
    method: "GET",
  });
};
export const delBalance = (ids) => {
  return request({
    url: `${baseUrl}/joins-wallet/v1/balance/${ids}`,
    method: "DELETE",
  });
};

export const addBalance = (params) => {
  return request({
    url: `${baseUrl}/joins-wallet/v1/app_recharge`,
    method: "POST",
    data: params,
  });
};
export const immediatePay = (params) => {
  return request({
    url: `${baseUrl}/joins-wallet/v1/balance`,
    method: "PUT",
    data: params,
  });
};
